import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import "../assets/styles/home.css"
import DaySelector from "./dayselector";
import FilterButton from "./filterbutton";
import MonthSelector from "./monthselector";
import YearSelector from "./yearselector";
import { months } from 'moment';
import uumcLogo from "../assets/images/uumc-logo.jpg";
import { Toast } from 'bootstrap';
import SearchComp from './searchcomp';

const Home = () => {

    

    return (
        <div className="container">
            <div className='col'>
                <SearchComp/>
            </div>
        </div>
    );
}

export default Home;